import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";
import ResendVerificationEmail from "../components/ResendVerificationEmail";

const ResendVerification = () => {
  return (
    <>
      <Meta title={"Resend Verification Email"} />
      <BreadCrumb title="Resend Verification Email" />
      <Container class1="login-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <div className="auth-card">
              <ResendVerificationEmail />
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default ResendVerification;